import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import Cluster from 'react-leaflet-cluster';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.css';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.Default.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Configuración de iconos por defecto de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const StoresMap = ({ position, stores }) => {
  const userIcon = new L.Icon({
    iconUrl: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
    iconSize: [32, 32],
    iconAnchor: [16, 32],
  });

  return (
    <MapContainer
      center={[position.lat, position.lng]}
      zoom={10}
      style={{ width: '100%', height: '400px' }}
    >
      <TileLayer
        url="https://wms.ign.gob.ar/geoserver/gwc/service/tms/1.0.0/capabaseargenmap@EPSG%3A3857@png/{z}/{x}/{-y}.png"
        attribution='<a href="https://www.ign.gob.ar/">Instituto Geográfico Nacional</a> | &copy; OpenStreetMap contributors'
      />

      {/* Tu ubicación */}
      <Marker position={[position.lat, position.lng]} icon={userIcon}>
        <Popup>Tu ubicación</Popup>
      </Marker>

      {/* Cluster de pizzerías */}
      <Cluster
        iconCreateFunction={(cluster) => {
          const count = cluster.getChildCount();
          return L.divIcon({
            html: `<div style="
              background-color: rgba(51,136,255,0.7);
              border-radius: 50%;
              color: white;
              width: 40px;
              height: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 2px solid white;
              font-weight: bold;
              font-size: 14px;
            ">${count}</div>`,
            className: 'custom-cluster',
            iconSize: [40, 40],
          });
        }}
        maxClusterRadius={30}            
      >
        {stores
          .filter((store) => store.lat != null && store.lng != null)
          .map((store, index) => (
            <Marker key={index} position={[store.lat, store.lng]}>
              <Popup>
                <a
                  href={store.link}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <div style={{ display: 'flex' }}>
                    <div style={{ width: 80, marginRight: 10 }}>
                      <img
                        src={store.logo}
                        alt={store.name}
                        style={{ width: '80px', height: 'auto' }}
                        onError={(e) =>
                          (e.currentTarget.src = '/images/site/default-logo.png')
                        }
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '18px', margin: 0 }}>
                        {store.name}
                      </h3>
                      <p style={{ margin: '2px 0' }}>{store.address}</p>
                      {store.promotions &&
                        store.promotions.map((p, i) => (
                          <div
                            key={i}
                            style={{ marginTop: 5, fontSize: '14px' }}
                          >
                            <h5 style={{ margin: 0 }}>{p.description}</h5>
                            <p style={{ margin: 0, fontSize: '12px' }}>
                              {p.cash ? 'Solo efectivo' : 'Todos los medios de pago'} -{' '}
                              {p.delivery ? 'Delivery ' : ''}
                              {p.takeaway ? 'Takeaway ' : ''}
                              {p.eatin ? 'Salón' : ''}
                            </p>
                          </div>
                        ))}
                    </div>
                  </div>
                </a>
              </Popup>
            </Marker>
          ))}
      </Cluster>
    </MapContainer>
  );
};

export default StoresMap;
